import { render, staticRenderFns } from "./TableWidget.vue?vue&type=template&id=6384767e&scoped=true"
import script from "./TableWidget.vue?vue&type=script&lang=ts"
export * from "./TableWidget.vue?vue&type=script&lang=ts"
import style0 from "./TableWidget.vue?vue&type=style&index=0&id=6384767e&prod&lang=scss&scoped=true"
import style1 from "./TableWidget.vue?vue&type=style&index=1&id=6384767e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6384767e",
  null
  
)

export default component.exports